import { render } from "./Cast.vue?vue&type=template&id=1dcd4fb0"
import script from "./Cast.vue?vue&type=script&lang=js"
export * from "./Cast.vue?vue&type=script&lang=js"
script.render = render

export default script